import { render, staticRenderFns } from "./GuidedTour.vue?vue&type=template&id=6abc4f56&scoped=true&"
import script from "./GuidedTour.vue?vue&type=script&lang=ts&"
export * from "./GuidedTour.vue?vue&type=script&lang=ts&"
import style0 from "./GuidedTour.vue?vue&type=style&index=0&id=6abc4f56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc4f56",
  null
  
)

export default component.exports